<template>
  <div>
  <Card>
      <SelectServer ref="SelectServer" v-on:selectServerComplete="selectServerComplete"></SelectServer>
      <Modal v-model="selectOsModal" title="选择操作系统">
        <RadioGroup v-model="selectedOs">
          <Radio label="linux">
            <span>Linux</span>
          </Radio>
          <Radio label="windows">
            <span>Windows</span>
          </Radio>
        </RadioGroup>
        <div slot="footer">
          <Button type="primary" @click="selectServer">确定</Button>
          <Button @click="selectOsModal = false" style="margin-left: 8px">取消</Button>
        </div>
      </Modal>
       <Drawer
        title="插件批量操作"
        v-model="changeAgent"
        width="780"
        :mask-closable="true"
        @on-close="drawerCloseAgent"
      >
      <i-form ref="formItemAgent" :label-width="0">
         <form-item>
          <RadioGroup v-model="rdOperateSel" @on-change="actionChange">
          <Radio label="install">
              <Icon type="md-hammer" />
              <span>安装</span>
          </Radio>
          <Radio label="config">
              <Icon type="md-arrow-round-up" />
              <span>配置</span>
          </Radio>
          <!-- <Radio label="uninstall">
              <Icon type="md-close" />
              <span>卸载</span>
          </Radio> -->
        </RadioGroup>
        </form-item>
        <form-item v-if="rdOperateSel === 'install'">
          <p>当前正在进行第 {{ currentInstall + 1 }} 步</p>
          <Steps :current="currentInstall">
              <Step title="添加主机"></Step>
              <Step title="执行安装"></Step>
          </Steps>
        </form-item>
        <form-item v-if="rdOperateSel === 'config'">
          <p>当前正在进行第 {{ currentConfig + 1 }} 步</p>
          <Steps :current="currentConfig">
              <Step title="添加主机"></Step>
              <Step title="配置采集路径"></Step>
              <Step title="开始执行"></Step>
          </Steps>
        </form-item>
          <form-item v-if="rdOperateSel === 'uninstall'">
          <p>当前正在进行第 {{ currentUninstall + 1 }} 步</p>
          <Steps :current="currentUninstall">
              <Step title="添加主机"></Step>
              <Step title="执行卸载"></Step>
          </Steps>
        </form-item>
        <form-item>
           <Button type="success" ghost @click="selectOsModal=true" v-show="addHostShow">添加主机</Button>
        </form-item>
        <form-item label="" :label-width="10" v-show="configInputShow">
           <i-input  v-model="configInput" placeholder="填入Filebeat YAML 文件内容" type="textarea" :autosize="{minRows: 20}"></i-input>
           <!-- <Input v-model="configInput" placeholder="如有多个日志采集路径, 请用英文分号 ; 分隔 " /> -->
        </form-item>
        <form-item>
          <Button type="primary" @click="before" :disabled="disabledBefore">上一步</Button>
          <Button type="primary" style="margin-left: 8px" @click="next" :disabled="disabledNext">下一步</Button>
           <i-button type="primary"  style="margin-left: 400px"  @click="handleExecute" :disabled="disabledAction" :loading="executeLoading">开始执行</i-button>
           <i-button style="margin-left: 8px" @click="changeAgent=false">取消执行</i-button>
        </form-item>
        </i-form>
        <spin fix v-if="changeLoadingShow">
          <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
          <div>请求中</div>
        </spin>
      </Drawer>
    </Card>
  </div>
</template>
<script>
import Tables from '_c/tables'
import { configAgent, unInstallAgent, installAgent, getHostLogConfig } from '@/api/log'
import SelectServer from '@/view/ops-center/select-server'
export default {
  name: 'AgentList',
  components: {
    Tables,
    SelectServer
  },
  data () {
    return {
      executeLoading: false,
      configInputShow: false,
      configInput: '',
      addHostShow: true,
      currentServer: {},
      disabledBefore: true,
      disabledNext: true,
      disabledAction: true,
      currentInstall: 0,
      currentConfig: 0,
      currentUninstall: 0,
      selectOsModal: false,
      selectedOs: 'linux',
      trashZone: [],
      searchForm: {
        name: null
      },
      rdOperateSel: 'install',
      osList: [
        {
          value: '0',
          label: 'Linux'
        },
        {
          value: '1',
          label: 'Windows'
        }
      ],
      count: 0,
      size: 10,
      page: 1,
      latestWinVersion: '',
      latestLinuxVersion: '',
      agentSelectVersion: '',
      tableData: [],
      changeAgent: false,
      changeLoadingShow: false
    }
  },
  watch: {
    currentServer () {
      if (Object.keys(this.currentServer).length === 0) {
        this.disabledBefore = true
        this.disabledNext = true
        this.currentInstall = 0
        this.currentConfig = 0
        this.currentUninstall = 0
        this.addHostShow = true
        this.configInputShow = false
        this.disabledAction = true
      } else {
        this.currentInstall = 1
        this.currentConfig = 1
        this.currentUninstall = 1
        if (this.rdOperateSel === 'config') {
          if (this.configInput) {
            this.disabledNext = false
          } else {
            this.disabledNext = true
          }
          this.configInputShow = true
        } else {
          this.configInputShow = false
          this.disabledNext = true
          this.disabledAction = false
        }
        this.disabledBefore = false
        this.addHostShow = false
      }
    },
    configInput () {
      if (this.configInput) {
        this.disabledNext = false
      } else {
        this.disabledNext = true
      }
    }
  },
  methods: {
    actionChange (value) {
      this.currentServer = {}
      this.resetButton()
    },
    resetButton () {
      this.disabledBefore = true
      this.disabledNext = true
      this.disabledAction = true
      this.configInputShow = false
    },
    before () {
      this.disabledAction = true
      this.addHostShow = true
      this.disabledNext = false
      this.disabledBefore = true
      if (this.rdOperateSel === 'install') {
        if (this.currentInstall === 1) {
          this.currentInstall = 0
        } else {
          this.currentInstall = 0
        }
      } else if (this.rdOperateSel === 'config') {
        if (this.currentConfig === 1) {
          this.currentConfig = 0
          this.configInputShow = false
        } else if (this.currentConfig === 2) {
          this.currentConfig = 1
          this.disabledBefore = false
          this.addHostShow = false
          this.configInputShow = true
        }
      } else if (this.rdOperateSel === 'uninstall') {
        if (this.currentUninstall === 1) {
          this.currentUninstall = 0
        } else {
          this.currentUninstall = 0
        }
      }
    },
    next () {
      this.disabledBefore = false
      this.disabledNext = true
      this.disabledAction = false
      this.addHostShow = false
      if (this.rdOperateSel === 'install') {
        if (this.currentInstall === 0) {
          this.currentInstall = 1
        } else {
          this.currentInstall = 1
        }
      } else if (this.rdOperateSel === 'config') {
        if (this.currentConfig === 0) {
          this.currentConfig = 1
          this.configInputShow = true
          this.disabledAction = true
          if (this.configInput) {
            this.disabledNext = false
          } else {
            this.disabledNext = true
          }
        } else if (this.currentConfig === 1) {
          this.currentConfig = 2
          this.configInputShow = false
        } else {
          this.currentConfig = 2
        }
      } else if (this.rdOperateSel === 'uninstall') {
        if (this.currentUninstall === 0) {
          this.currentUninstall = 1
        } else {
          this.currentUninstall = 1
        }
      }
    },
    selectServer () {
      this.selectOsModal = false
      // 获取通道 agent（非插件filebeat）状态为正常 true 的机器
      this.$refs.SelectServer.openSelectServerModal({troop_status: true, os: this.selectedOs === 'windows' ? 1 : 0}, this.currentServer, '', false)
    },
    selectServerComplete (server) {
      if (Object.keys(server).length) {
        this.currentServer = server
        // 选择主机后 调用api读取之前的配置文件
        this.readConfig()
      } else {
        this.currentServer = {}
      }
    },
    handleExecute () {
      this.executeLoading = true
      if (this.rdOperateSel === 'install') {
        this.handleSubmitInstall()
      } else if (this.rdOperateSel === 'config') {
        this.handleConfig()
      } else if (this.rdOperateSel === 'uninstall') {
        this.handleDelete()
      }
      this.changeAgent = false
      this.$emit('completeAction')
    },
    readConfig () {
      if (Object.keys(this.currentServer).length > 0) {
        this.changeLoadingShow = true
        let host = Object.keys(this.currentServer)[0]
        let data = { host: host }
        getHostLogConfig(data).then(res => {
          if (res.status === 200) {
            console.log(res.data)
            this.configInput = res.data
          } else {
            this.$Message.error('读取配置失败')
          }
          this.executeLoading = false
        }).catch(res => {
          this.executeLoading = false
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        })
      } else {
        this.$Notice.error({title: '请至少选择一台主机进行升级！'})
      }
      this.changeLoadingShow = false
    },
    handleConfig () {
      if (Object.keys(this.currentServer).length > 0) {
        this.changeLoadingShow = true
        let hosts = Object.keys(this.currentServer)
        let data = {config_yml: this.configInput, hosts: hosts}
        configAgent(data).then(res => {
          if (res.status === 200) {
            this.changeAgent = false
          } else {
            // this.$Notice.error({title: res.data})
            this.$Message.error(res.data.msg)
          }
          this.executeLoading = false
        }).catch(res => {
          this.executeLoading = false
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        })
      } else {
        this.$Notice.error({title: '请至少选择一台主机进行升级！'})
      }
      this.changeLoadingShow = false
    },
    handleDelete () {
      if (Object.keys(this.currentServer).length > 0) {
        this.changeLoadingShow = true
        let ids = this.tableData.map(item => item.id)
        let data = { 'ids': ids, 'version': this.agentSelectVersion }
        unInstallAgent(data).then(res => {
          if (res.data.code === 200) {
            this.changeAgent = false
          } else {
            // this.$Notice.error({title: res.data})
            this.$Message.error(res.data.msg)
          }
          this.executeLoading = false
        }).catch(res => {
          this.executeLoading = false
          console.log(res.response)
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        })
      } else {
        this.$Notice.error({title: '请至少选择一台主机进行卸载！'})
      }
      this.changeLoadingShow = false
    },
    handleSubmitInstall () {
      if (Object.keys(this.currentServer).length > 0) {
        this.changeLoadingShow = true
        let hosts = Object.keys(this.currentServer)
        let data = { 'hosts': hosts }
        installAgent(data).then(res => {
          if (res.data.code === 200) {
            this.changeAgent = false
            this.executeLoading = false
          } else {
            // this.$Notice.error({title: res.data})
            this.$Message.error(res.data.msg)
          }
          this.executeLoading = false
        }).catch(res => {
          this.executeLoading = false
          console.log(res.response)
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        })
      } else {
        this.$Notice.error({title: '请至少选择一台主机进行安装！'})
      }
      this.changeLoadingShow = false
    },
    drawerCloseAgent () {
    }
  },
  mounted () {
    console.log('AgentList mounted')
  }
}
</script>
